interface WithSpinnerOptions<T> {
  action: () => Promise<T>;
  onStateUpdate: (isSpinning: boolean, prevValue: boolean) => void;
  minDuration?: number;
  spinnerDelay?: number;
}

export async function withSpinner<T>({
  action,
  onStateUpdate,
  minDuration = 350,
  spinnerDelay = 100,
}: WithSpinnerOptions<T>): Promise<T> {
  let start: number | undefined;
  let spinnerTimeout: ReturnType<typeof setTimeout> | undefined;

  const showSpinner = () => {
    start = Date.now();
    onStateUpdate(true, false);
  };

  const hideSpinner = () => {
    clearTimeout(spinnerTimeout);
    onStateUpdate(false, true);
  };

  try {
    if (spinnerDelay > 0) {
      spinnerTimeout = setTimeout(showSpinner, spinnerDelay);
    } else {
      showSpinner();
    }

    const result = await action();

    return result;
  } finally {
    // ensure the spinner is shown for at least the provided minimum duration, even if it fails
    if (start) {
      const elapsedTime = Date.now() - start;

      if (elapsedTime < minDuration) {
        await new Promise((resolve) => setTimeout(resolve, minDuration - elapsedTime));
      }
    }

    hideSpinner();
  }
}
